import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { NavBar } from "./components/NavBar/NavBar";
import { Home } from "./components/Home/Home";
import { Contact } from "./components/Contact/Contact";
import SkillsPage from "./components/Skills/Skill";
import ProjectsPage from "./components/Project/Project";
import Footer from "./components/Footer/Footer";
import CertificatePage from "./components/Certificate Page/Certificates";

function App() {
  return (
    <>
      <NavBar />
      <Home />
      <SkillsPage />
      <ProjectsPage />
      <CertificatePage />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
